import { SVGProps, Ref, forwardRef } from 'react';

export const ThumbDownFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.644 20.964c-.121 1.494-1.729 2.486-3.143 1.812-1.484-.708-2-2.163-2-3.787v-3H5c-3.407-.105-4.38-1.404-3.876-4.993l.702-5c.524-3.724 1.945-4.983 5.673-5h9v15.196c-1.09 1.576-1.717 3.058-1.856 4.772m3.656-5.98c3.51-.143 4.7-1.54 4.7-5.322V6.33c0-3.781-1.19-5.18-4.7-5.321z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ThumbDownFilledSize24Glyph.displayName = 'ThumbDownFilledSize24Glyph';
